import { formatCompactCurrency } from "@/lib/calculators";
import { MRR_MOVEMENTS_SERIES } from "./exampleData";
import {
  CHART_NEGATIVE,
  CHART_NEGATIVE_MUTED,
  CHART_POSITIVE,
  CHART_POSITIVE_MUTED,
  CHART_POSITIVE_SEMI_MUTED,
} from "./chartTheme";
import StackedMovementsChart, { type MovementSeries } from "./StackedMovementsChart";

/** Gains stack up, losses stack down — the app's POSITIVE_NEGATIVE stacked view. */
const SERIES: MovementSeries[] = [
  { key: "new", name: "New", color: CHART_POSITIVE },
  { key: "expansion", name: "Expansion", color: CHART_POSITIVE_MUTED },
  { key: "reactivation", name: "Reactivation", color: CHART_POSITIVE_SEMI_MUTED },
  { key: "contraction", name: "Contraction", color: CHART_NEGATIVE_MUTED },
  { key: "churn", name: "Churn", color: CHART_NEGATIVE },
];

/**
 * MRR movements over time — new, expansion and reactivation stacked above the
 * zero line, contraction and churn below, with net new MRR as a line. Matches the
 * app's stacked movements chart.
 */
const MrrMovementsChart = () => (
  <StackedMovementsChart
    caption="Each month stacks gains — new, expansion and reactivation — above the line and losses — contraction and churn — below it. The line is net new MRR: where it sits above zero, the book grew."
    data={MRR_MOVEMENTS_SERIES}
    series={SERIES}
    netKey="net"
    netName="Net new MRR"
    format={(v) => formatCompactCurrency(Number(v))}
  />
);

export default MrrMovementsChart;
